import { render, staticRenderFns } from "./ExpenseByTransferItem.vue?vue&type=template&id=cdec5220&lang=pug&"
import script from "./ExpenseByTransferItem.vue?vue&type=script&lang=ts&"
export * from "./ExpenseByTransferItem.vue?vue&type=script&lang=ts&"
import style0 from "./ExpenseByTransferItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports